/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Cook_MinInputs */

const en_editor_cook_min = /** @type {(inputs: Editor_Cook_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cook (min)`)
};

const de_editor_cook_min = /** @type {(inputs: Editor_Cook_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kochen (Min.)`)
};

/**
* | output |
* | --- |
* | "Cook (min)" |
*
* @param {Editor_Cook_MinInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_cook_min = /** @type {((inputs?: Editor_Cook_MinInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Cook_MinInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_cook_min(inputs)
	return en_editor_cook_min(inputs)
});